(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('componentReplacement', {
        templateUrl: 'views/components/views/componentReplacement/componentReplacement.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'componentReplacementService', function ($stateParams, stateService, modalService, translateService, componentReplacementService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let bomComponentReplaceKeyno = $stateParams.bom_component_replace_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                bomComponentReplaceKeyno: bomComponentReplaceKeyno,
                edit: {},
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadEdit() {
                vm.model.edit = (await componentReplacementService.getComponentReplacement({ bom_component_replace_keyno: bomComponentReplaceKeyno }))[0];
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region TYPEAHEAD SEARCH FUNCTION CALL

            vm.prodSearch = function (value, searchparam) {
                return componentReplacementService.prodSearchKeyname(value, searchparam);
            };

            vm.prodSelectItem = function (item, model) {
                if (item?.prod_id && item.prod_id !== '') {

                    vm.model.edit.prod_id = item.prod_id;
                    vm.model.edit.prod_name = item.prod_name;
                    vm.model.edit.prod_keyname = item.prod_keyname;
                }
            };

            // #endregion TYPEAHEAD SEARCH FUNCTION CALL

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                
                componentReplacementService.save(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    componentReplacementService.delete(vm.model.edit).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: (dialogItself) => {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        }
                    }, () => vm.model.lockedDelete = false);
                }, () => vm.model.lockedDelete = false);
            }

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region LIFECYCLE FUNCTION

            vm.$onInit = async function () {
                translate();
                loadEdit();
            }

            // #endregion LIFECYCLE FUNCTION

        }]
    });
})();
